/* eslint-disable prettier/prettier */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import abcjsObj from "abcjs";
//import { AudioManager } from "./audio/AudioManager"
import {
  noteCleaner,
  noteFromAbcNote,
  findLyricsByPlayedPath,
} from "../lib/noteHelper";
import { manipulateMelodyByConfig } from "../lib/scoreHelper";
import {
  drawBallsBelowBars,
  drawNoteNameAboveNote,
  drawRectBetweenBars,
  drawTriangleAboveNote,
  makeTriangleOverBar,
  drawNoteBoundingBox,
  drawLengthSquaresOverAll,
} from "../lib/scorePainterHelper";

class Abc extends PureComponent {
  static propTypes = {
    program: PropTypes.number,
    score: PropTypes.object,
    scoreOptions: PropTypes.object,
    onNotePlay: PropTypes.func,
    cursorType: PropTypes.string, // style | box
    drum: PropTypes.bool,
    voicesOff: PropTypes.bool,
    chordsOff: PropTypes.bool,
    showPlayCursor: PropTypes.bool,
    bpm: PropTypes.number,
    playing: PropTypes.bool.isRequired,
    currentTime: PropTypes.number.isRequired,
    onAudioTimeUpdate: PropTypes.func,
    onPlaybackFinished: PropTypes.func,
    showConfigurationButton: PropTypes.bool,
    onConfigurationButtonClicked: PropTypes.func,
  };

  uniqueNumber = Date.now(); // + Math.random();

  constructor(props) {
    super(props);

    this.state = {
      melody: false,
      baseUrl: null,
      melodyUrl: null,
      ghostMelody: false,
      // configurations:
      configurationVisible: false,
      drumNote: "A1",
    };
    this.abcjsCanvasRef = React.createRef();
    this.ghostCanvasRef = React.createRef();
    this.baseAudioPlayerRef = React.createRef();
    this.melodyAudioPlayerRef = React.createRef();
    this.metronomeRef = React.createRef();
    this.metronome = null;
    this.alreadyPlayed = false;
    this.hasGhostRendering = false;
    // TIMING CALLBACKS:
    this.timingListener = null;
    this.timingParams = {
      eventCallback: this.onTimingEvent,
    };
    this.originalBpm = null;

    // graphical stuff:
    this.previousRange = null;
    this.lastLine = null;
    this.lineChanged = false;
    this.currentMeasure = null;
    this.startingBeats = 0;
    this.selectedMeasures = {};
    this.baseDuration = 0;

    this.scrollContainer = React.createRef();
  }

  //TODO: se cambia BPM insieme agli altri??
  componentWillReceiveProps(nextProps) {

    const { drum, score, bpm, currentTime, playing } = nextProps;

    if (this.props.drum !== drum) {
      this.metronomeRef.current.volume = drum ? 1 : 0;
    }
    if (score.id !== this.props.score.id) {
      this.loadMusic(this.uniqueNumber, score).finally();
    } else if (bpm && bpm !== this.props.bpm) {
      this.bpmChanged(bpm);
    }
    if (
      currentTime !== this.props.currentTime ||
      playing !== this.props.playing
    ) {
      this.updatePlayStatus(playing, currentTime);
    }
  }

  handleDrumChange = (event) => {
    const mode = event.target.value;
    this.metronomeRef.current.src = window.MIDI.Soundfont.percussion[mode];
    this.setState({ drumNote: mode });
  };

  render() {
    const { debug, lineSpacing } = this.props.scoreOptions;

    let innerResultClasses = "abcjs-result";

    let abcHolderClasses = "Abc-Holder";
    if (this.props.scoreOptions.staffOrientation === "horizontal") {
      const lineSpacingClasses = ["Small", "Normal", "Large"];
      abcHolderClasses += " Abc-Staff-Horizontal";
      abcHolderClasses += " Abc-" + lineSpacingClasses[lineSpacing] + "-Score";
    }

    let abcInnerClasses = "Abc-Inner";
    if (this.props.scoreOptions.staffOrientation !== "horizontal") {
      abcInnerClasses = "Abc-Inner-Tutor";
      innerResultClasses += " Abc-Result-Inner-Tutor";
    }

    return (
      <div className={abcHolderClasses}>
        {!this.props.showConfigurationButton && (
          <div className="Abc-Configuration-Button">
            <button className="Eye" onClick={this.toggleConfigurationDialog}>
              Occhio
            </button>
          </div>
        )}
        <div className={abcInnerClasses} ref={this.scrollContainer}>
          {debug && (
            <select
              value={this.state.drumNote}
              onChange={this.handleDrumChange}
            >
              {Object.entries(window.MIDI.Soundfont.percussion).map((x, i) => {
                return (
                  <option key={"drum" + i} value={x[0]}>
                    {x[0]}
                  </option>
                );
              })}
            </select>
          )}
          <div
            className={innerResultClasses}
            id={"abcjs-result-" + this.uniqueNumber}
            ref={this.abcjsCanvasRef}
          />
          {this.state.baseUrl && (
            <audio
              id="base-audio"
              ref={this.baseAudioPlayerRef}
              src={process.env.PUBLIC_URL + this.state.baseUrl}
              preload="auto"
              controls
              onTimeUpdate={this.onAudioTimeUpdate}
              style={{ display: "none" }}
              onCanPlayThrough={this.updateMuted}
              onLoadedMetadata={this.getBaseDuration}
              onLoad={this.onBaseReady}
            />
          )}
          {this.state.melodyUrl && (
            <audio
              id="melody-audio"
              ref={this.melodyAudioPlayerRef}
              src={process.env.PUBLIC_URL + this.state.melodyUrl}
              controls
              preload="auto"
              style={{ display: "none" }}
              onCanPlayThrough={this.updateMuted}
              onLoad={this.onMeloadyReady}

            />
          )}
          <audio
            id="metro-audio"
            preload="auto"
            ref={this.metronomeRef}
            src={window.MIDI.Soundfont.percussion[this.state.drumNote]}
          />
        </div>
        <div
          id={"abcjs-ghost-result-" + this.uniqueNumber}
          ref={this.ghostCanvasRef}
        />
      </div>
    );
  }

  getBaseDuration = (event) => {

    this.baseDuration = Math.floor(event.target.duration);
    if (this.props.onTuneLoaded) {

      this.props.onTuneLoaded(
        this.tunes[0],
        Math.floor(this.baseDuration),
        this.state.melody
      );
      if (this.scrollContainer && this.scrollContainer.current) {
        this.scrollContainer.current.scrollTop = 0;
      }
    }
  }
  componentDidMount() {
    const { score } = this.props;
    this.loadMusic(this.uniqueNumber, score).finally();
    this.updateMuted();
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    if (prevProps.scoreOptions.staffOrientation !== this.props.scoreOptions.staffOrientation) {
      const { score, drum } = this.props;
      this.loadMusic(this.uniqueNumber, score, drum).finally();
    }
    if (prevProps.chordsOff !== this.props.chordsOff) {
      if (this.baseAudioPlayerRef && this.baseAudioPlayerRef.current) {
        this.baseAudioPlayerRef.current.volume = this.props.chordsOff ? 0 : 1;
      }
    }
    if (prevProps.voicesOff !== this.props.voicesOff) {
      console.log("this.props.voicesOff", this.props.voicesOff, (this.props.voicesOff ? 0 : 1));
      if (this.melodyAudioPlayerRef && this.melodyAudioPlayerRef.current) {
        this.melodyAudioPlayerRef.current.muted = this.props.voicesOff ? 1 : 0;
      }
    }
    if (prevProps.bpm !== this.props.bpm) this.resetTune();
    if (
      prevProps.scoreOptions.selectedStaffLine !==
      this.props.scoreOptions.selectedStaffLine
    ) {
      this.highlightStaffLine();
    }
    if (
      prevProps.scoreOptions.noteLengthVisible !==
      this.props.scoreOptions.noteLengthVisible
    ) {
      this.drawNoteLength();
    }
    if (
      prevProps.scoreOptions.staffOrientation !==
      this.props.scoreOptions.staffOrientation ||
      prevProps.scoreOptions.notesNameVisible !==
      this.props.scoreOptions.notesNameVisible
    ) {
      this.resetTune();
      this.renderAbcNotation(
        this.uniqueNumber,
        this.props.score,
        this.props.drum
      );
    }
  }

  componentWillUnmount() {
    this.timingListener.stop();
    this.baseAudioPlayerRef.current.pause();
    this.melodyAudioPlayerRef.current.pause();
    if (this.metronome !== null) {
      this.metronome.tearDown();
      this.metronome = null;
    }
  }

  renderGhostCanvas(uniqueNumber, engraverParams, renderParams) {
    if (this.state.ghostMelody !== false) {
      const {
        staffOrientation,
        notesNameVisible,
        noteLengthVisible,
      } = this.props.scoreOptions;

      this.ghostCanvasRef.current.classList.add("hideghost");
      this.currentGhostMelody = manipulateMelodyByConfig(
        this.state.ghostMelody,
        staffOrientation,
        notesNameVisible,
        noteLengthVisible
      );

      this.ghostTunes = abcjsObj.renderAbc(
        "abcjs-ghost-result-" + uniqueNumber,
        this.currentGhostMelody,
        Object.assign({}, {}, engraverParams, renderParams)
      );

      return true;
    }
    return false;
  }

  renderAbcNotation(uniqueNumber, score) {
    console.log("RenderAbcNotation", uniqueNumber, score, this.state.melody);

    const {
      staffOrientation,
      notesNameVisible,
      noteLengthVisible,
    } = this.props.scoreOptions;
    // crea testo abc a partire dalla configurazione

    this.currentMelody = manipulateMelodyByConfig(
      this.state.melody,
      staffOrientation,
      notesNameVisible,
      noteLengthVisible
    );

    const engraverParams = { add_classes: true };
    const renderParams = {
      clickListener: this.onNoteClicked,
    };
    if (staffOrientation === "vertical") {
      engraverParams.responsive = "resize";
    } else {
      renderParams.scrollHorizontal = true;
      renderParams.viewportHorizontal = true;
      renderParams.staffwidth = 1000;
    }

    this.hasGhostRendering = this.renderGhostCanvas(
      uniqueNumber,
      engraverParams,
      renderParams
    );

    this.tunes = abcjsObj.renderAbc(
      "abcjs-result-" + uniqueNumber,
      this.currentMelody,
      Object.assign({}, {}, engraverParams, renderParams)
    );

    // abcjs_renderer setta overflow: hidden a abcjs-inner per default (non ho capito perchè)
    window.removeEventListener("resize", this.resizeResultsHotFix);
    window.removeEventListener('rewind', this.rewindFromButton);
    if (staffOrientation === "horizontal") {
      const abcjscontainer = document.querySelector(
        "#abcjs-result-" + uniqueNumber
      );
      document.querySelector(".abcjs-inner").style.removeProperty("overflow");
      abcjscontainer.style.removeProperty("padding-bottom");
      abcjscontainer.style.removeProperty("vertical-align");
      abcjscontainer.style.removeProperty("position");
      abcjscontainer.style.removeProperty("display");
      document.getElementsByClassName("abcjs-inner")[0].style.height = 0;
      document.getElementsByClassName("abcjs-inner")[0].style.paddingTop = 30;
    }
    window.addEventListener("resize", this.resizeResultsHotFix);
    window.addEventListener("rewind", this.rewindFromButton);
    // configure timing parameters:
    this.originalBpm =  this.tunes[0].metaText.tempo.bpm;
    const tempo = this.props.bpm || this.tunes[0].metaText.tempo.bpm;
    this.createTimingListener(tempo)
    
    console.log('** HAS GHOST ** ',this.hasGhostRendering)
    if (this.props.onTuneLoaded) {
      console.log('loading tunes')
      this.props.onTuneLoaded(
        this.tunes[0],
        Math.floor(this.baseDuration),
        this.state.melody
      );
      if (this.scrollContainer && this.scrollContainer.current) {
        this.scrollContainer.current.scrollTop = 0;
      }
    }
    // staff add-ons. Colora il rigo selezionato, e disegna rettangoli per lunghezza note.
    this.highlightStaffLine();
    this.drawNoteLength();
    const classes = [];

    if (this.hasGhostRendering) {
      this.ghostCanvasRef.current
        .querySelectorAll(".abcjs-note, .abcjs-rest")
        .forEach((note) => {
          note.classList.forEach((className) => {
            if (className.startsWith("abcjs-d")) {
              classes.push(classes);
            }
          });
        });
      this.ghostCanvasRef.current.classList.add("hideghost");
      let canvasRendering = this.ghostCanvasRef.current.querySelectorAll('.abcjs-inner');
      canvasRendering.forEach(render => {
        render.classList.add('hideghost');
      })

    }
    this.resizeResultsHotFix();
    const speakAt = this.props.score.playAt || 0;
    let i = 0;


    this.abcjsCanvasRef.current
      .querySelectorAll(".abcjs-note, .abcjs-rest")
      .forEach((note) => {
        if (i < speakAt) {
          const lyrics = findLyricsByPlayedPath(
            this.abcjsCanvasRef.current,
            note
          );
          const canAddClass = !note.classList.contains("abcjs-square");
          if (!canAddClass) i -= 1;
          else note.classList.add("note-muted");

          if (lyrics) lyrics.classList.add("note-muted");
        }
        if (this.hasGhostRendering) {
          note.classList.forEach((className) => {
            if (className.startsWith("abcjs-d")) {
              note.classList.remove(className);
              note.classList.add(classes[i]);
            }
          });
        }

        i++;
      });
  }

  onBaseReady = () => {
    console.log("onBaseLoaded");
    this.baseAudioPlayerRef.current.pause();
    this.baseAudioPlayerRef.current.currentTime = 0.0;
    this.baseAudioPlayerRef.current.muted = false;
  }

  onMeloadyReady = () => {
    console.log("onMeloadyReady");
    this.melodyAudioPlayerRef.current.pause()
    this.melodyAudioPlayerRef.current.currentTime = 0.0
    this.melodyAudioPlayerRef.current.muted = false;
  }

  rewindFromButton = (_event) => {
    if (this.metronome !== null) {
      // this.metronome.tearDown();
      // this.metronome = null;
      this.metronomeRef.current.pause()
      this.metronomeRef.current.currentTime = 0.0;
    }
  }

  getScrollBarWidth = () => {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
  };

  // questo è un brutto fix da riguardare per evitare che abcjs (src/api/abcjs_tunebook_svg.js:16)
  // metta un width: xx a abcjs-result, che crea una doppia scrollbar che impedisce a this.scrollScore di funzionare
  // correttamente
  resizeResultsHotFix = () => {
    try {
      document
        .querySelector("#abcjs-result-" + this.uniqueNumber)
        .style.removeProperty("width");
    } catch (e) {
      console.log("Error during resize", e);
    }

    try {
      const { staffOrientation } = this.props.scoreOptions;
      const staff = document.querySelector(".Abc-Holder");
      const configButton = document.querySelector('.Abc-Configuration-Button');
      const parent = document.querySelector(".Abc-Score");
      if (staffOrientation == "horizontal") {
        const me = this;
        setTimeout(function () {
          const mainInstruent = document.querySelector('.Main-Instrument');
          const mainInstruentHeight = mainInstruent.offsetHeight;
          const height = (parent.offsetHeight - mainInstruentHeight) / 2
          const staffHeight = staff.offsetHeight / 2
          var currentStaffHeight = Math.max(Math.floor(height - staffHeight - me.getScrollBarWidth() - 50), 0);
          parent.setAttribute('style', 'padding-top:' + currentStaffHeight + "px;")
          configButton.setAttribute('style', 'padding-top:' + currentStaffHeight + "px;")
        }, 20);
      } else {
        parent.removeAttribute('style')
        configButton.removeAttribute('style')
      }

      console.log("RESIZE", this.getScrollBarWidth())

    } catch (e) {
      console.warn('error resizing staff', e.message);
    }
  };

  // disegna quadrati/rettangoli sopra le note a seconda della loro durata
  drawNoteLength = () => {
    const { staffOrientation, noteLengthVisible } = this.props.scoreOptions;
    if (staffOrientation === "horizontal" && noteLengthVisible) {
      drawLengthSquaresOverAll(
        this.abcjsCanvasRef.current,
        this.tunes[0].engraver.renderer.paper
      );
    } else {
      const squares = this.abcjsCanvasRef.current.querySelectorAll(
        ".abcjs-square-group"
      );
      squares.forEach((x) => {
        x.remove();
      });
    }
  };

  // colora il rigo del pentagramma selezionato (e cancella gli altri)
  highlightStaffLine = () => {
    const selectedLine = this.props.scoreOptions.selectedStaffLine;
    this.tunes[0].lines.forEach((_x, i) => {
      const lines = this.abcjsCanvasRef.current.querySelectorAll(
        ".abcjs-staff.abcjs-l" + i
      );
      lines.forEach((x, i) => {
        x.setAttribute("fill", i === selectedLine ? "red" : "#000000");
      });
    });
  };

  highlight = (elements, options) => {
    if (!elements) {
      return;
    }

    elements.forEach((e) => {
      e.forEach((f) => {
        // consider only path/text/rect (elements we change somehow)
        if (
          f.nodeName !== "path" &&
          f.nodeName !== "text" &&
          f.nodeName !== "rect"
        )
          return;


        // if option is set we force removal of class 'cursor'
        if (options && options.remove) f.classList.remove("cursor");
        // skip hilight if note is muted
        const isNoteMuted = f.classList.contains("note-muted");
        if (isNoteMuted) {
          return;
        }
        // check options for cursor types.
        else if (options) {
          if (options.bbox && f.classList.contains("abcjs-note")) {
            drawNoteBoundingBox(this.tunes[0].engraver.renderer.paper, f);
          }
          if (options.bbox && f.classList.contains("abcjs-note")) {
            drawTriangleAboveNote(
              this.abcjsCanvasRef.current,
              this.tunes[0].engraver.renderer.paper,
              f
            );
          }
          if (options.easystyle) {
            f.classList.add("easy-cursor");
          }
          // in everything else we only add a 'cursor' class
          if (options.style) {
            f.classList.add("cursor");
            if (f.nodeName == 'path') {
              this.highlightNoteLenght(f);
            }
          }
        }
      });
    });
  };

  animate = (arg, arg2) => {
    // clean everything we drawed before.
    this.abcjsCanvasRef.current
      .querySelectorAll(".easy-cursor")
      .forEach((x) => {
        x.classList.toggle("easy-cursor");
      });
    this.abcjsCanvasRef.current
      .querySelectorAll(".abcjs-square.cursor")
      .forEach((x) => {
        x.classList.remove("cursor");
      });
    this.abcjsCanvasRef.current.querySelectorAll(".box-cursor").forEach((x) => {
      x.remove();
    });
    this.abcjsCanvasRef.current
      .querySelectorAll(".arrow-cursor")
      .forEach((x) => {
        x.remove();
      });

    // handle note logic.
    this.onNotePlay(arg, arg2);
    // handle graphical stuff that need to change on note play
    if (this.props.showPlayCursor) {
      // select new elements:
      if (arg2) {
        if (this.selectedMeasures.start && this.selectedMeasures.end) {
          let { line, measure } = this.selectedMeasures.end;
          //let {lineS } = this.selectedMeasures.start;

          if (arg2.measureNumber > measure && arg2.line >= line) {
            if (this.props.playing)
              this.startTune();
          }
          if (arg2.line > line) {
            if (this.props.playing)
              this.startTune();
          }
        }
        this.highlight(arg2.elements, {
          arrow: this.props.cursorType === "arrow",
          bbox: this.props.cursorType === "box",
          easystyle: this.props.cursorType === "easystyle",
          style: this.props.cursorType === "style",
        });
      }

      if (arg) {
        this.highlight(arg.elements, { remove: true });
      }
    }
  };

  getLineMeasureNumbersFromSvgElement = (svgElement) => {
    let measure = -1;
    let line = -1;
    svgElement.classList.forEach((className, _index) => {
      if (className.startsWith("abcjs-l")) {
        line = parseInt(className.replace("abcjs-l", ""));
      }
      if (className.startsWith("abcjs-m")) {
        measure = parseInt(className.replace("abcjs-m", ""));
      }
    });
    return { line, measure };
  };

  // arguments: abcElem, tuneNumber, classes
  onNoteClicked = (abcElem) => {
    if (
      abcElem &&
      abcElem.abselem &&
      abcElem.abselem.elemset &&
      abcElem.abselem.elemset.length > 0
    ) {
      const path = abcElem.abselem.elemset[0];
      // se ho cliccato su un elemento cerco di prenderne line e numero di battuta.
      // la barra con quei due numeri indica la fine della battuta, io cerco l'inizio, quindi
      // se measure == 0, devo prendere l'ultima barra della riga precedente.
      let { measure, line } = this.getLineMeasureNumbersFromSvgElement(path);
      if (measure === 0) {
        if (line > 0) {
          line--;
          const a = this.abcjsCanvasRef.current.querySelectorAll(
            `.abcjs-bar.abcjs-l${line}`
          );
          const lastBar = a[a.length - 1];
          measure = this.getLineMeasureNumbersFromSvgElement(lastBar).measure;
        } else {
          measure = -1;
        }
      } else {
        measure--;
      }
      // got line and measureNumber...
      this.selectedMeasures.start = { line, measure };
      this.selectedMeasures.end = null;
      this.updateMeasureSelection();
    }
  };

  clearMeasureSelection = () => {
    this.selectedMeasures.start = null;
    this.selectedMeasures.end = null;
    this.updateMeasureSelection();
  };

  enlargeMeasureSelection = () => {
    const canvas = this.abcjsCanvasRef.current;
    const { start, end } = this.selectedMeasures;

    let { line, measure } = start;
    if (end) {
      line = end.line;
      measure = end.measure + 1;
    } else {
      measure += 1;
    }
    // cerco la lunghezza della riga:
    const a = canvas.querySelectorAll(`.abcjs-bar.abcjs-l${line}`);
    const numberOfLines = document.querySelectorAll(".abcjs-top-line").length;
    const lastLine = numberOfLines - 1;
    if (measure >= a.length) {
      if (line < lastLine) {
        line++;
        measure = 0;
      }
    }
    if (measure >= a.length) { measure = a.length - 1; }
    this.selectedMeasures.end = { line, measure };
    this.updateMeasureSelection();
  };

  updateMeasureSelection = () => {
    const canvas = this.abcjsCanvasRef.current;
    const paper = this.tunes[0].engraver.renderer.paper;
    // remove old selection:
    canvas.querySelectorAll(".abcjs-bar-selection-element").forEach((v) => {
      v.remove();
    });
    // new selection:
    const { start, end } = this.selectedMeasures;
    const fill = end ? "#eb6075" : null;
    if (!start) return;
    makeTriangleOverBar(
      canvas,
      paper,
      start.line,
      start.measure,
      fill,
      this.enlargeMeasureSelection
    );
    if (end) {
      makeTriangleOverBar(
        canvas,
        paper,
        end.line,
        end.measure,
        null,
        this.clearMeasureSelection
      );
    }
  };

  async loadMusic(uniqueNumber, score) {
    const isHorizontalStaffOrientation =
      this.props.scoreOptions.staffOrientation === "horizontal";
    let url;
    let baseUrl = null;
    let melodyUrl = null;
    let urlghost = null;
    if (score.type === "simple") {
      url = "/music" + score.path;
    } else if (score.type === "dir") {
      url =
        "/music" +
        score.path +
        "/" +
        (isHorizontalStaffOrientation ? "h-" : "") +
        "melodia.abc";
      baseUrl = "/music" + score.path + "/base.mp3";
      melodyUrl = "/music" + score.path + "/melodia.mp3";
      urlghost =
        "/music" +
        score.path +
        "/" +
        (isHorizontalStaffOrientation ? "h-" : "") +
        "ghost-melodia.abc";
    }
    try {
      const res = await fetch(process.env.PUBLIC_URL + url);
      const data = await res.text();
      const hasToResync = this.props.score.manualSync === true || false;
      let ghostdata = false;
      if (hasToResync) {
        let ghostUrl = process.env.PUBLIC_URL + urlghost;
        const ghostFile = await fetch(ghostUrl);
        ghostdata = await ghostFile.text();
      }

      this.setState(
        {
          ghostMelody: ghostdata,
          melody: data,
          baseUrl: baseUrl,
          melodyUrl: melodyUrl,
        },
        () => {
          this.renderAbcNotation(uniqueNumber, score);
        }
      );
    } catch (e) {
      console.warn(e);
      this.setState({ error: "Ops... impossibile caricare lo sparito.." });
    }
  }

  getPathFromClass = (elements, className) => {
    let path = null;
    let rest = className === "abcjs-rest";
    for (let j = 0;
      j < elements.length; j++) {
      if (elements[j].classList.contains(className)) {
        path = elements[j];
        break;
      }
    }
    return { path: path, rest: rest };
  };

  // Evidenzia il rettagolo sopra le note
  highlightNoteLenght = (path) => {
    if (!path) {
      return;
    }
    path.previousSibling.childNodes.forEach((x) => {
      if (!x.classList) return;
      x.classList.add(
        this.props.cursorType === "easystyle" ? "easy-cursor" : "cursor"
      );
    });

  };

  onNotePlay = (previousRange, currentRange) => {
    if (currentRange) {
      const startChar = currentRange.startChar;
      const endChar = currentRange.endChar;
      const melody = this.currentMelody;
      const currentSource = melody.substring(startChar, endChar);
      let measureChanged = false;
      let lineChanged = false;
      let duration = 0;
      if (currentRange.elements && currentRange.elements.length) {
        // path puo' non essere una nota
        const currentNote = noteFromAbcNote(currentSource);
        const elements = currentRange.elements[0];
        let pathData = this.getPathFromClass(elements, "abcjs-note");
        let path = pathData.path;

        if (path !== null) {
          path.classList.forEach((className, _i) => {
            if (className.startsWith("abcjs-d")) {
              duration = className.replace("abcjs-d", "").replace("-", ".");
            }
          });
        }
        if (previousRange) {
          if (previousRange.measureNumber !== currentRange.measureNumber) {
            measureChanged = true;
          }
          if (previousRange.line !== currentRange.line) lineChanged = true;
        }
        if (currentNote) {
          const {
            noteLengthVisible,
            showCurrentNoteName,
          } = this.props.scoreOptions;

          const beatsPerBar = this.tunes[0].getMeterFraction().den;
          currentNote.duration =
            duration * this.timingListener.millisecondsPerBeat * beatsPerBar;
          this.removeBySelector(".drawed-by-drawNoteNameAboveNote");
          const currentPath = currentRange.elements[0][0];
          if (showCurrentNoteName) {
            drawNoteNameAboveNote(
              this.abcjsCanvasRef.current,
              this.tunes[0].engraver.renderer.paper,
              currentPath,
              currentNote.traditionalName()
            );
          }

          if (noteLengthVisible && path !== null && !path.classList.contains("note-muted")) {
            this.highlightNoteLenght(path);
          }
        } else {
          const { noteLengthVisible } = this.props.scoreOptions;
          // Se non è una nota facciamo una verifica, e cerchiamo se è una pausa
          pathData = this.getPathFromClass(elements, "abcjs-rest");
          path = pathData.path;
          if (
            path != null &&
            pathData.rest &&
            !path.classList.contains("note-muted") &&
            noteLengthVisible
          ) {
            this.highlightNoteLenght(path);
          }
        }
        if (this.props.onNotePlay) {
          let notes = noteCleaner(currentSource);
          // if (currentNote) {
          //   console.log(
          //     "onNotePlay",
          //     currentNote.toAbcString(),
          //     currentNote.traditionalName()
          //   );
          // }

          this.props.onNotePlay(
            notes,
            measureChanged,
            lineChanged,
            currentNote,
            path
          );
        }
      }
    } else {
      this.props.onNotePlay(null);
    }
  };

  // timing callbacks:

  onTimingEvent = (currentEvent) => {
    // se currentEvent è null siamo oltre il "lastMoment"
    if (currentEvent === null) {
      if (this.selectedMeasures.start && this.selectedMeasures.end) {
        this.startTune()
      }
    } else {
      if (this.lastLine !== currentEvent.line) this.lineChanged = true;
      this.lastLine = currentEvent.line;
      this.animate(this.previousRange, currentEvent);
      this.previousRange = currentEvent;
      this.currentMeasure = currentEvent.measureNumber;
      const tDiff = Math.abs(this.melodyAudioPlayerRef.current.currentTime - currentEvent.milliseconds /1000);
      const resyncNumb = 0.2;
      if(tDiff >resyncNumb && this.props.bpm === this.originalBpm){
        console.log("Before resync...",this.baseAudioPlayerRef.current.currentTime,this.melodyAudioPlayerRef.current.currentTime,tDiff);
        this.baseAudioPlayerRef.current.currentTime = this.melodyAudioPlayerRef.current.currentTime = (currentEvent.milliseconds /1000)
        console.log("After resync...",this.baseAudioPlayerRef.current.currentTime,this.melodyAudioPlayerRef.current.currentTime,currentEvent.milliseconds,(currentEvent.milliseconds/1000));
        

      }
    }
  };

  animateMeasures = (currentBeat, _totalBeats, _tuneLength) => {
    const beatsPerBar = this.tunes[0].getMeterFraction().num;
    const canvas = this.abcjsCanvasRef.current;
    const paper = this.tunes[0].engraver.renderer.paper;
    const showMeasureProgress = this.props.scoreOptions.showMeasureProgress;

    if (
      currentBeat <
      beatsPerBar * this.timingListener.extraMeasuresAtBeginning
    ) {
      this.startingBeats++;
      return;
    }

    
    currentBeat -= this.startingBeats;
    //const barNumber = Math.floor(currentBeat / beatsPerBar);
    let barNumber = this.currentMeasure;

    // expected fraction is one more of the previous beat. but currentBeat starts from 0
    //              1 2 | 1 2 3 4
    // beat % num   1 0 | 1 2 3 0
    // expected %   0 1 | 1 2 3 4
    const barQuarter = (currentBeat % beatsPerBar) + 1;

    // METRONOMO:
    if (this.props.drum) {
      setImmediate(() => {
        //this.metronomeRef.current.pause();
        this.metronomeRef.current.currentTime = 0.0;
        this.metronomeRef.current.play();
      });
    }
    // recupera la battuta corrente:
    let barPath;
    if (this.lineChanged || this.lastLine === null || barNumber === 0) {
      const line = this.lastLine === null ? 0 : this.lastLine;
      barPath = canvas.querySelectorAll(
        ".abcjs-staff.abcjs-top-line.abcjs-l" + line
      )[0];
      this.lineChanged = false;
    } else {
      barPath = canvas.querySelectorAll(".abcjs-bar.abcjs-l" + this.lastLine)[
        barNumber - 1
      ];
    }
    const line = this.lastLine === null ? 0 : this.lastLine;
    const nextBarPath = canvas.querySelectorAll(".abcjs-bar.abcjs-l" + line)[
      barNumber
    ];
    if (barPath === undefined || nextBarPath === undefined) return;
    if (showMeasureProgress) {
      // disegna il rettangolo dietro il pentagramma:
      drawRectBetweenBars(
        canvas,
        paper,
        barPath,
        nextBarPath,
        beatsPerBar,
        barQuarter
      );
      // disegna i pallini sotto il pentagramma:
      drawBallsBelowBars(
        canvas,
        paper,
        barPath,
        nextBarPath,
        beatsPerBar,
        barQuarter,
        line
      );
      // TODO: disegna la riga verticale:
    }
    // scrolla lo spartito:

    this.scrollScore(barPath, line);
  };

  // TODO: separare questa funzione in due, una per modalità di visualizzazione (orizzontale/verticale)
  scrollScore = (barPath, line) => {
    const currBox = barPath.getBBox();
    if (this.props.scoreOptions.staffOrientation === "horizontal") {
      // sistema di riferimento -> svg
      const svgWidth = document.querySelector(".abcjs-inner svg").getBBox()
        .width;
      const svgX = currBox.x;
      // sistema di riferimento -> html
      const svgDrawedWidth = document
        .querySelector(".abcjs-inner svg")
        .getBoundingClientRect().width;
      const el = document.getElementsByClassName("abcjs-result")[0];
      const { offsetWidth } = el;
      const x = (svgX * svgDrawedWidth) / svgWidth;
      //console.log("currBox",line,currBox, svgWidth, svgX, svgDrawedWidth, offsetWidth);
      if (x > offsetWidth / 2) {
        el.scrollLeft = x - offsetWidth / 2;
      } else {
        el.scrollLeft = 0;
      }
    } else {
      // abcjs-staff-extra abcjs-l0  calcolare
      let scrollValue = 0;
      const svgElement = document.getElementById(
        "abcjs-result-" + this.uniqueNumber
      ).firstElementChild;
      const allTopLines = svgElement.querySelectorAll(".abcjs-top-of-system");
      const step = svgElement.clientHeight / allTopLines.length
      if (line !== 0) {
        scrollValue = (step * line) -step;
      }
      this.scrollContainer.current.scrollTop = scrollValue - (step);
    }
  };

  // Player callbacks/handlers

  updateMuted = () => {
    const { voicesOff, chordsOff } = this.props;
    if (this.baseAudioPlayerRef && this.baseAudioPlayerRef.current) {
      this.baseAudioPlayerRef.current.volume = chordsOff ? 0 : 1;
    }
    if (this.melodyAudioPlayerRef && this.melodyAudioPlayerRef.current) {
      this.melodyAudioPlayerRef.current.volume = voicesOff ? 0 : 1;

    }
  };

  onAudioTimeUpdate = () => {
    if (this.props.onAudioTimeUpdate)
      this.props.onAudioTimeUpdate(this.baseAudioPlayerRef.current.currentTime);
  };

  getMeasureSecondsFromStart = (line, measure, _tag) => {
    if (this.abcjsCanvasRef.current === null) return -1;
    const bars = this.abcjsCanvasRef.current.querySelectorAll(`.abcjs-bar.abcjs-l${line}`);
    const nextBar = this.abcjsCanvasRef.current.querySelectorAll(`.abcjs-bar.abcjs-l${line + 1}`).length > 0;
    if (measure === bars.length - 1) {
      if (nextBar && measure !== 0) {
        line++;
        measure = 0;
      }
    } else {
      measure++;
    }

    const lineNotes = this.tunes[0].noteTimings.filter((note) => {
      return note.line === line && note.measureNumber === measure;
    });
    return lineNotes[0];

  };

  startTune = () => {
    if (this.selectedMeasures.start && this.selectedMeasures.end) {
      let { line, measure } = this.selectedMeasures.start;
      const startTimeObj = this.getMeasureSecondsFromStart(line, measure, "start");
      const startTime = startTimeObj.milliseconds;
      if (startTime < 0) return;

      this.goToTimestamp(startTime / 1000);
      line = this.selectedMeasures.end.line;
      measure = this.selectedMeasures.end.measure;

    }
    this.melodyAudioPlayerRef.current.play().then(() => {
    })
    this.baseAudioPlayerRef.current.play().then(() => {
      this.melodyAudioPlayerRef.current.currentTime = this.baseAudioPlayerRef.current.currentTime;
    })

    this.timingListener.start();
  };

  pauseTune = () => {
    this.timingListener.pause();
    this.baseAudioPlayerRef.current.pause();
    this.melodyAudioPlayerRef.current.pause();
    this.metronomeRef.current.pause();
  };

  removeBySelector = (selectorString) => {
    this.abcjsCanvasRef.current
      .querySelectorAll(selectorString)
      .forEach((e) => e.remove());
  };

  resetTune = () => {
    this.pauseTune();
    this.timingListener.reset();
    this.baseAudioPlayerRef.current.currentTime = 0.0;
    this.melodyAudioPlayerRef.current.currentTime = 0.0;

    // CLEAN everything:
    if (this.previousRange) {
      this.highlight(this.previousRange.elements, { remove: true });
      this.previousRange = null;
    }

    this.removeBySelector(".drawed-by-drawRectBetweenBars");
    this.removeBySelector(".drawed-by-drawNoteNameAboveNote");
    this.removeBySelector(".drawed-by-drawBallsBelowBars");

    this.lastLine = null;
    this.lineChanged = false;
    this.currentMeasure = null;
    this.startingBeats = 0;
    // parent notification
    this.onAudioTimeUpdate();
  };

  // in seconds?
  goToTimestamp = (timestamp) => {
    const percent = (timestamp * 1000) / this.timingListener.lastMoment;
    this.timingListener.setProgress(percent);
    this.baseAudioPlayerRef.current.currentTime = timestamp;
    this.melodyAudioPlayerRef.current.currentTime = timestamp;
    this.onAudioTimeUpdate();
  };

  createTimingListener(tempo){
    this.timingParams.qpm = tempo
    if (this.props.score.startingMeasures)
      this.timingParams.extraMeasuresAtBeginning = this.props.score.startingMeasures;

    const timingsElements = new abcjsObj.TimingCallbacks(
      this.tunes[0],
      this.timingParams
    ).noteTimings;
    // Utilizziamo i tempi del file fantasma per usarli nella callback
    this.timingListener = new abcjsObj.TimingCallbacks(
      this.hasGhostRendering ? this.ghostTunes[0] : this.tunes[0],
      this.timingParams
    );
    this.timingListener.beatCallback = this.animateMeasures;
    this.timingListener.lineCallback = null;

    this.timingListener.noteTimings.forEach((tune,eventId) => {
      tune.elements = timingsElements[eventId].elements;
      eventId++;
    });
  }

  bpmChanged = (value) => {
    if (this.tunes[0].metaText.tempo.bpm === undefined) {
      console.warn('metaText.tempo.bpm is undefined...exiting')
      return;
    }
    const currMelody  = this.tunes[0];
    const rate = value / currMelody.metaText.tempo.bpm;
    this.resetTune();
    this.createTimingListener(value);
    this.baseAudioPlayerRef.current.playbackRate = rate;
    this.melodyAudioPlayerRef.current.playbackRate = rate;
  };



  updatePlayStatus = (playing, currentTime) => {
    if (playing === this.props.playing && currentTime !== 0) return;
    if (!playing) this.pauseTune();
    if (currentTime === 0) {
      this.resetTune();
    }
    if (playing) this.startTune();
  };

  

  // CONFIGURATION MANAGEMENT:
  toggleConfigurationDialog = () => {
    if (this.props.onConfigurationButtonClicked) {
      this.props.onConfigurationButtonClicked();
      if (this.metronome !== null) {
        this.selectedMeasures = {};
      }
      const me = this;
      setTimeout(function () {
        me.resizeResultsHotFix();
      }, 500)
    }
  };
}

export default Abc;
